import { call, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import { errorMessages } from "lib/utils/constants";
import {
  fetchAddressDetails,
  saveAddressDetails,
  updateApplicationState,
  updateInitialValues,
  updateIsPageLoading,
  updateIsSaving,
} from "components/Form/AddressDetails/redux/AddressDetailsSlice";
import {
  requestAddressDetails,
  requestSaveAddressDetails,
} from "components/Form/AddressDetails/redux/AddressDetailsApi";
import Router from "next/router";
import { triggerInschoolTrackForm } from "lib/utils/events_utils";
import { mutateAddressDetailsValues } from "components/Form/AddressDetails/redux/addressDetailsHelper";

const getStore = (store) => store?.addressDetails;

function* handleFetchAddressDetails(action) {
  try {
    yield put(updateIsPageLoading(true));
    const res = yield call(requestAddressDetails, action.payload);
    if (res.data) {
      yield put(updateInitialValues(res?.data?.application));
      yield put(
        updateApplicationState(res?.data?.application?.applicationState)
      );
    } else {
      toast.error(errorMessages.SOMETHING_WENT_WRONG);
    }
  } catch (err) {
    console.error(err);
    toast.error(errorMessages.SOMETHING_WENT_WRONG);
  } finally {
    yield put(updateIsPageLoading(false));
  }
}

function* handleSaveAddressDetails(action) {
  try {
    yield put(updateIsSaving(true));
    const res = yield call(
      requestSaveAddressDetails,
      mutateAddressDetailsValues(action.payload)
    );
    const { initialValues: application } = yield select(getStore);
    yield call(triggerInschoolTrackForm, {
      values: action.payload,
      applicationId: application?.id,
      screen: application?.applicationState?.screen,
      nextStage: res?.success && res?.data,
    });
    if (res.success) {
      Router.push(
        `/applications/${action.payload.slug}/${res?.data?.toLowerCase()}`
      );
    } else {
      toast.error(errorMessages.SOMETHING_WENT_WRONG);
    }
  } catch (err) {
    console.error(err);
    toast.error(errorMessages.SOMETHING_WENT_WRONG);
  } finally {
    yield put(updateIsSaving(false));
  }
}

function* addressDetailsSaga() {
  yield takeLatest(fetchAddressDetails, handleFetchAddressDetails);
  yield takeLatest(saveAddressDetails, handleSaveAddressDetails);
}

export default addressDetailsSaga;
